import { render, staticRenderFns } from "./ModalRegraIndicacaoIncluir.vue?vue&type=template&id=59cc4e40&scoped=true"
import script from "./ModalRegraIndicacaoIncluir.vue?vue&type=script&lang=ts"
export * from "./ModalRegraIndicacaoIncluir.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegraIndicacaoIncluir.vue?vue&type=style&index=0&id=59cc4e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cc4e40",
  null
  
)

export default component.exports